import { render, staticRenderFns } from "./informView.vue?vue&type=template&id=550a7b3d&"
import script from "./informView.vue?vue&type=script&lang=js&"
export * from "./informView.vue?vue&type=script&lang=js&"
import style0 from "./informView.vue?vue&type=style&index=0&id=550a7b3d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports